var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nyx-modal",class:{
    'nyx-modal--open': _vm.modalIsOpen,
    'nyx-modal--transparent': _vm.isTransparent,
  }},[_c('div',{staticClass:"nyx-modal__content",class:{
      'nyx-modal__content--large': _vm.isLarge,
    }},[_c('div',{staticClass:"d-flex align-items-center justify-content-end"},[(_vm.hasClose)?_c('a',{staticClass:"nyx-text-icon nyx-text-icon--large",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.closeModal}},[_c('i',{staticClass:"bi bi-x-square"})]):_vm._e()]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }